module.exports = __webpack_public_path__ + "europa-20-front.jpg?b1cdfef1b59136ab3aa17829d3054cae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20-front.jpg
// module id = 294
// module chunks = 0